<template>
  <div>
    <div class="confirmation">
      <div class="container">
        <Loading
          :active.sync="loading"
          :can-cancel="false"
          :is-full-page="fullPage"
        />

        <div class="confirmation__group">
          <h1 class="confirmation__title-group" v-if="canConfirmPayment">
            Revise os detalhes do agendamento
          </h1>
          <div class="confirmation__infor">
            <div class="confirmation__infor-card">
              <div class="confirmation__image-wrapper">
                <base-avatar size="lg" :src="fallbackPhoto()" />
              </div>
              <h3 class="confirmation__doctor-name">
                {{ SPECIALIST_NAMES[doctorSpecialty.id] }}
              </h3>
              <div class="confirmation____infor-doctor">
                <span class="">
                  {{ councilDetails }}
                </span>
              </div>
              <div class="confirmation_list-infor">
                <div class="confirmation_list-item">
                  <p class="confirmation_list-title">Data da consulta</p>
                  <span class="confirmation_list-content">
                    {{ formatDate }}
                  </span>
                </div>
                <div class="confirmation_list-item">
                  <p class="confirmation_list-title">Hora da consulta</p>
                  <span class="confirmation_list-content">
                    {{ currentSchedule.slot_hour }}
                  </span>
                </div>
                <div class="confirmation_list-item">
                  <p class="confirmation_list-title">Especialidade</p>
                  <span class="confirmation_list-content">
                    {{
                      currentSchedule.doctor.doctor_property
                        .medical_specialty_name
                    }}
                  </span>
                </div>
                <div class="confirmation_list-item">
                  <p class="confirmation_list-title">Modalidade escolhida</p>
                  <span class="confirmation_list-content">Consulta online</span>
                </div>
                <div class="confirmation_list-item">
                  <p class="confirmation_list-title">Observação</p>
                  <span class="confirmation_list-content">
                    {{ this.observation }}
                  </span>
                </div>
              </div>
              <span class="confirmation__line" v-if="canConfirmPayment" />
              <div
                class="confirmation__card-group"
                v-if="canConfirmPayment && !isPublicInstitution"
              >
                <div class="confirmation__card-content">
                  <p
                    class="confirmation__card-name"
                    v-if="selectedPaymentMethod == 'credit_card'"
                  >
                    {{ selectedCreditCard.nickname }}
                    {{ selectedCreditCard.last_four }}
                  </p>
                  <p
                    class="confirmation__card-name"
                    v-if="selectedPaymentMethod == 'pix'"
                  >
                    Pix
                  </p>
                  <p class="confirmation__card-payment">
                    {{
                      convertToBrl(
                        currentSchedule.doctor.doctor_property
                          .price_cents_and_earning_margin_sum
                      )
                    }}
                  </p>
                </div>
                <button class="button2" @click.prevent="changeCreditCard">
                  Alterar
                </button>
              </div>
              <span
                v-if="!isPublicInstitution"
                class="confirmation__line confirmation__line--bottom"
              />
              <div class="confirmation__result">
                <div
                  v-if="this.doctorCoupons.length"
                  class="confirmation__result-item"
                >
                  <p class="confirmation__result-subtitle">Subtotal</p>
                  <p class="confirmation__result-value">
                    {{
                      formatConsultationPrice(
                        currentSchedule.doctor.doctor_property
                          .consultation_price_formatted
                      )
                    }}
                  </p>
                </div>

                <div
                  v-if="this.doctorCoupons.length"
                  class="confirmation__result-item"
                >
                  <p class="confirmation__result-subtitle coupon">
                    {{ couponTypes[doctorCoupons[0].coupon_type] }}
                  </p>
                  <p class="confirmation__result-value coupon">
                    -{{
                      formatConsultationPrice(
                        currentSchedule.doctor.doctor_property
                          .consultation_price_formatted
                      )
                    }}
                  </p>
                </div>

                <div
                  v-if="selectedInsuranceEnrollment.id"
                  class="confirmation__result-item"
                  style="margin-bottom: 48px;"
                >
                  <p
                    class="confirmation__result-title confirmation__result-text-grey"
                  >
                    Desconto com convênio
                  </p>
                  <p
                    class="confirmation__result-value confirmation__result-text-grey"
                  >
                    -{{
                      normalizePriceText(
                        convertToBrl(priceWthPercentageDiscount)
                      )
                    }}
                  </p>
                </div>

                <div
                  v-if="!isPublicInstitution"
                  class="confirmation__result-item"
                >
                  <p class="confirmation__result-title">Total</p>
                  <p class="confirmation__result-value">
                    <span
                      v-if="selectedInsuranceEnrollment.id"
                      class="confirmation__result-new-value"
                    >
                      {{
                        doctorCoupons.length
                          ? convertToBrl(
                              doctorCoupons[0].appointment_total_value
                            )
                          : normalizePriceText(
                              convertToBrl(
                                currentSchedule.doctor.doctor_property
                                  .price_cents_and_earning_margin_sum
                              )
                            )
                      }}
                    </span>
                    {{
                      doctorCoupons.length
                        ? convertToBrl(doctorCoupons[0].appointment_total_value)
                        : normalizePriceText(
                            convertToBrl(
                              selectedInsuranceEnrollment.id
                                ? doctorPriceWithDiscount
                                : currentSchedule.doctor.doctor_property
                                    .price_cents_and_earning_margin_sum
                            )
                          )
                    }}
                  </p>
                </div>
              </div>

              <div
                class="confirmation__button"
                @click="sendAppointment"
                v-if="canConfirmPayment"
              >
                <span href="#" class="button3 confirmation__button3">
                  {{ comfirmationButtonText }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { format, parseISO } from "date-fns";
import { appointmentsMethods, doctorMethods } from "./../state/helpers";
import { intToBRL } from "./../utils/currency/convert";
import { SPECIALIST_NAMES } from "../utils/constants";

export default {
  name: "CardScheduleConsult",
  components: {
    Loading
  },
  props: {
    selectedInsuranceEnrollment: { type: Object, default: null },
    selectedCreditCard: { type: Object, default: null },
    selectedPaymentMethod: { type: String, default: null },
    step: { type: Number, default: 0 },
    observation: { type: String, default: null },
    isPublicInstitution: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      fullPage: true,
      appointmentResponse: null,
      SPECIALIST_NAMES
    };
  },
  mounted() {
    this.getDoctorCoupons(this.currentSchedule.doctor.id);
  },
  methods: {
    ...mapActions("slot", ["createTimeSuggestion"]),
    ...appointmentsMethods,
    ...doctorMethods,
    formatConsultationPrice,
    sendAppointment() {
      swal
        .fire({
          title: "Confirmar agendamento?",
          icon: "warning",
          text: "",
          showCancelButton: true,
          showLoaderOnConfirm: true,
          preConfirm: () => {
            const payload = {
              scheduled_at: `${this.currentSchedule.slot_date} ${this.currentSchedule.slot_hour}:00`,
              scheduled_until: `${this.currentSchedule.slot_date} 00:00:00`,
              doctor_id: this.currentSchedule.doctor.id,
              slot_id: this.currentSchedule.slot_id,
              payment_type: this.selectedPaymentMethod,
              observation: this.observation
            };

            if (this.currentSchedule.institution_id) {
              payload["institution_id"] = this.currentSchedule.institution_id;
            }

            if (this.doctorCoupons.length) {
              payload["coupon_id"] = this.doctorCoupons[0].id;
            }

            if (this.selectedInsuranceEnrollment.id) {
              payload["insurance_id"] = this.selectedInsuranceEnrollment.id;
            }

            if (this.selectedPaymentMethod == "credit_card")
              payload.credit_card_id = this.selectedCreditCard.id;

            if (this.isTimeSuggestion) {
              return this.createTimeSuggestion(this.currentSchedule.suggestion)
                .then(response => (this.appointmentResponse = response.data))
                .catch(error => {
                  this.loading = false;
                  swal.fire({
                    icon: "error",
                    title: "Erro ao processar a transação",
                    text: "Entre em contato com a sua operadora de cartão!"
                  });
                });
            } else {
              return this.scheduleAppointment(payload)
                .then(response => (this.appointmentResponse = response.data))
                .catch(error => {
                  this.loading = false;
                  swal.fire({
                    icon: "error",
                    title: "Erro ao processar a transação",
                    text: "Entre em contato com a sua operadora de cartão!"
                  });
                });
            }
          },
          allowOutsideClick: () => !swal.isLoading()
        })
        .then(result => {
          if (result.isConfirmed) {
            swal.fire({
              icon: "success",
              title: "Sucesso",
              text: "Agendamento realizado!"
            });
            this.$router
              .push({
                name: "Confirmation",
                params: {
                  payment_method: this.selectedPaymentMethod,
                  appointmentResponse: this.appointmentResponse,
                  isPublicInstitution: this.isPublicInstitution
                }
              })
              .then(() => {
                this.clearScheduleAppointment();
              });
          }
        });

      // this.loading = true;
    },
    fallbackPhoto() {
      if (this.currentSchedule.doctor)
        return (
          this.currentSchedule.doctor.photo ||
          require("./../assets/images/doctor-img.jpg")
        );

      return require("./../assets/images/doctor-img.jpg");
    },
    changeCreditCard() {
      this.$emit("changeCreditCard");
    },
    convertToBrl(price) {
      return intToBRL(price, true);
    },
    normalizePriceText(price) {
      return price.replace(/[,.]/g, c => (c === "." ? "," : ""));
    }
  },
  computed: {
    ...mapGetters("speciality", ["specialities"]),

    priceWthPercentageDiscount() {
      return (
        (this.selectedInsuranceEnrollment.percentage_discount *
          this.currentSchedule.doctor.doctor_property.price_cents) /
        100
      );
    },
    doctorPriceWithDiscount() {
      return (
        this.currentSchedule.doctor.doctor_property.price_cents -
        this.priceWthPercentageDiscount
      );
    },
    councilDetails() {
      return `${this.currentSchedule.doctor.doctor_property.council_name} ${this.currentSchedule.doctor.doctor_property.council_number} ${this.currentSchedule.doctor.doctor_property.council_uf}`;
    },

    currentSchedule() {
      return this.$store.state.appointments.currentSchedule;
    },

    formatDate() {
      return format(
        parseISO(this.currentSchedule.slot_date, "yyyy-MM-dd"),
        `dd/MM/yyyy`
      );
    },
    canConfirmPayment() {
      if (this.isPublicInstitution) {
        return true;
      } else {
        return (
          (this.selectedCreditCard.id &&
            this.step === 3 &&
            this.selectedPaymentMethod == "credit_card") ||
          (!this.selectedCreditCard.id &&
            this.step === 2 &&
            this.selectedPaymentMethod == "pix")
        );
      }
    },
    doctorCoupons() {
      return this.$store.state.doctor.coupons;
    },
    couponTypes() {
      return {
        follow_up: "Cupom de retorno"
      };
    },
    comfirmationButtonText() {
      return this.isPublicInstitution ? "Confirmar" : "Confirmar o pagamento";
    },
    doctorSpecialty() {
      let specialtyName = this.currentSchedule.doctor.doctor_property
        .medical_specialty_name;
      let specialityIndex = this.specialities.findIndex(
        specialty => specialty.name === specialtyName
      );
      return this.specialities[specialityIndex];
    },
    isTimeSuggestion() {
      let queryParams = new URLSearchParams(window.location.search);
      return queryParams.get("time_suggestion");
    }
  }
};
</script>

<style lang="scss">
.confirmation__result {
  display: flex;
  flex-direction: column;
  &-item {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &-value.coupon {
    color: #6fcf97 !important;
  }

  &-subtitle {
    font-size: 500;
    font-size: 14px;
    color: #717171;
    &.coupon {
      color: #6fcf97;
    }
  }
}

.confirmation__result-value {
  position: relative;
}

.confirmation__result-new-value {
  display: block;
  position: absolute;
  top: -28px;
  right: 0;
  color: #717171 !important;
  font-size: 15px;
  text-decoration: line-through;
}

.confirmation__result-text-grey {
  font-size: 15px !important;
  color: #717171 !important;
}
</style>
